import {Component, NgZone, OnInit} from '@angular/core';
import {Sincronizador} from "../../services/sincronizacao/Sincronizador";
import {AuthService, IdToken} from "@auth0/auth0-angular";
import { switchMap } from 'rxjs/operators';
import {CapacitorSQLite, SQLiteConnection} from "@capacitor-community/sqlite";
import {DataSource} from "typeorm";
import {Pessoa} from "../../domain/Pessoa";
import {PrimeNGConfig} from "primeng/api";
import {TranslateService} from "@ngx-translate/core";
import {Browser} from "@capacitor/browser";

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent  {
  ds?: DataSource

  constructor(public auth: AuthService) {
  }

  // async sincronizar(){
  //   const cnn = new SQLiteConnection(CapacitorSQLite)
  //   // await cnn.copyFromAssets(true)
  //   this.ds = new DataSource({
  //     type: 'capacitor',
  //     driver:  cnn,
  //     database: 'fauna',
  //     mode: 'no-encryption',
  //     entities: [Pessoa],
  //     migrations: [],
  //     subscribers: [],
  //     logging: ['query', 'error','schema'],
  //     synchronize: true,
  //     migrationsRun: false,
  //   })
  //   await this.ds.initialize()
  //
  // }



}
